export const urlFirstPage = ""
export const urlAdminPage = `${urlFirstPage}/admin`
export const urlSecondPage = `${urlFirstPage}/welcome`

//const ApiPath = "http://localhost:5005"
 const ApiPath = "https://anzscobackend.pasargadmigration.com"


export const ApiUrls = {
    //Visa
    VisaOption: `${ApiPath}/VisaOptions`, //GET
    GetANZSCO: `${ApiPath}/VisaOptions/GetANZSCO`, //GET ? filter
    GetANZSCOBaseData: `${ApiPath}/VisaOptions/GetANZSCOBaseData`, //GET ? id
    GetVisaOptions: `${ApiPath}/VisaOptions/GetVisaOptions`, //GET ? id
    GetTerritory: `${ApiPath}/VisaOptions/GetState_Territory`, //GET ? id
    GetTerritoryDetail: `${ApiPath}/VisaOptions/GetState_TerritoryDetail`, //GET ? id
    Getbacklogs: `${ApiPath}/VisaOptions/GetBackLog`, //GET ? id
    GetTask: `${ApiPath}/VisaOptions/GetTask`, //GET ? id
    Excel: `${ApiPath}/Excel`, //POST
    
}  
